<template>
  <v-container fluid>
    <v-row class="d-flex flex-row">
      <v-col cols="12">
        <FormInfoPage
          :data="infoPage"
          :infoCategories="infoCategories"
          :loading="isMutationLoading"
          :loadingData="isFormLoading"
          :isNew="!id"
          :language="language"
          @submit="formInfoPageSubmit"
          @delete-info-page="deleteInfoPage"
          @language-update="language = $event"
          @change:contentForMobile="changeContentForMobHandler($event)"
        />
      </v-col>
    </v-row>
    <ConfirmationDialog ref="confirmInfoPageRemove" confirmText="Удалить" />
  </v-container>
</template>

<script>
import FormInfoPage from './form'
import ConfirmationDialog from '@/components/confirmation-dialog'
import createInfoPage from '@/services/gql/types/InfoPages/mutations/createInfoPage.gql'
import deleteInfoPage from '@/services/gql/types/InfoPages/mutations/deleteInfoPage.gql'
import updateInfoPage from '@/services/gql/types/InfoPages/mutations/updateInfoPage.gql'
import infoPageQuery from '@/services/gql/types/InfoPages/queries/infoPage.gql'
import infoPageCategoriesQuery from '@/services/gql/types/InfoCategories/queries/infoCategories.gql'
import { contentLocales, contentLocalesValues } from '@/configs/locales'
import { getListWithNewMainLanguage, setTranslation } from '@/utils/locales'

export default {
  name: 'PageInfoPage',
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  components: {
    FormInfoPage,
    ConfirmationDialog
  },
  metaInfo () {
    return {
      title: this.id ? 'Редактировать страницу помощи' : 'Создать страницу помощи'
    }
  },
  data () {
    return {
      language: contentLocales[0].value,
      infoPage: null
    }
  },
  computed: {
    isMutationLoading () {
      return this.$async.createInfoPage.$pending || this.$async.updateInfoPage.$pending
    },
    isFormLoading () {
      return (
        this.$apollo.queries.infoPage.loading ||
        this.$apollo.queries.infoCategories.loading
      )
    }
  },
  methods: {
    changeContentForMobHandler ({ fields, $event }) {
      fields.contentForMobile = $event
    },
    async formInfoPageSubmit (infoPagePayload) {
      if (!this.id) {
        await this.createInfoPage(infoPagePayload)
      } else {
        await this.updateInfoPage(infoPagePayload)
      }
    },
    async createInfoPage (data) {
      try {
        delete data.translations
        await this.$async.createInfoPage.$perform({
          data
        })
        this.$successMsg('Страница помощи создана')
        await this.$router.push({ name: 'page-info-pages' })
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при создании страницы помощи')
      }
    },
    async deleteInfoPage () {
      try {
        await this.$refs.confirmInfoPageRemove.open()
        await this.$async.deleteInfoPage.$perform({ id: Number(this.id) })
        this.$successMsg('Страница помощи удалена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, `Ошибка при удалении страницы помощи с ID ${this.id}`)
      } finally {
        await this.$router.push({ name: 'page-info-pages' })
      }
    },
    async updateInfoPage (data) {
      try {
        setTranslation(data, this.language)
        await this.$async.updateInfoPage.$perform(
          {
            id: this.id,
            data
          },
          { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) }
        )
        this.$successMsg('Страница помощи изменена')
      } catch (e) {
        this.$handleApiError(e.graphQLErrors, 'Ошибка при редактировании страницы помощи')
      }
    }
  },
  apollo: {
    infoPage: {
      query: infoPageQuery,
      fetchPolicy: 'network-only',
      skip () {
        return !this.id
      },
      context () {
        return { headers: { Language: getListWithNewMainLanguage(this.language, contentLocalesValues()) } }
      },
      variables () {
        return {
          where: {
            id: this.id
          }
        }
      }
    },
    infoCategories: {
      query: infoPageCategoriesQuery,
      fetchPolicy: 'network-only',
      variables () {
        return {
          where: {}
        }
      },
      result (res) {
        this.infoCategories =
          res?.data?.infoCategories?.list?.map(category => ({
            ...category,
            // for nested parent - child logic in the form
            children: [],
            parentId: category?.parentCategory?.id || null
          })) || null
      }
    }
  },
  async: {
    createInfoPage (variables) {
      return this.$apollo.mutate({
        mutation: createInfoPage,
        variables
      })
    },
    deleteInfoPage (variables) {
      return this.$apollo.mutate({
        mutation: deleteInfoPage,
        variables
      })
    },
    updateInfoPage (variables, headers) {
      return this.$apollo.mutate({
        mutation: updateInfoPage,
        variables,
        context: {
          headers
        }
      })
    }
  }
}
</script>
